import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useServer } from "@/lib/server-context";
import { Trophy, Award, Medal, Coins } from "lucide-react";
import EmptyServer from "@/components/dashboard/EmptyServer";

export default function LeaderboardPanel() {
  const { active } = useServer();
  const [tab, setTab] = useState("xp");
  const [xp, setXp] = useState([]);
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    if (!active?.id || !active.bot_present) return;
    api.get(`/features/levels/${active.id}?limit=50`).then((r) => setXp(r.data));
    api.get(`/features/economy/${active.id}/leaderboard`).then((r) => setCoins(r.data));
  }, [active?.id, active?.bot_present]);

  if (!active) return <EmptyServer />;
  if (!active.bot_present) return <EmptyServer needsBot />;

  const data = tab === "xp" ? xp : coins;
  const trophy = (i) => i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : `#${i + 1}`;

  return (
    <div data-testid="leaderboard-panel" className="space-y-8">
      <div>
        <div className="overline mb-2"><Trophy className="inline w-4 h-4 mr-2 -mt-1" />MAIN</div>
        <h1 className="font-heading text-4xl font-bold uppercase tracking-tight">Leaderboard</h1>
        <p className="text-zinc-400 mt-2">Top members ranked by XP and Coins.</p>
      </div>

      <div className="flex gap-2">
        {[
          { id: "xp", label: "XP & Levels", icon: Award },
          { id: "coins", label: "Coins", icon: Coins },
        ].map((t) => {
          const Icon = t.icon;
          return (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={tab === t.id ? "btn-primary" : "btn-secondary"} data-testid={`lb-tab-${t.id}`}>
              <Icon className="w-4 h-4" /> {t.label}
            </button>
          );
        })}
      </div>

      <div className="tactical-card p-6">
        <div className="space-y-2">
          {data.length === 0 && (
            <div className="text-center py-12 text-zinc-500 font-mono-tabular text-sm">No data yet</div>
          )}
          {data.slice(0, 20).map((u, i) => (
            <div key={u.user_id} className={`border p-3 rounded-lg flex items-center gap-3 ${i < 3 ? "border-brand-orange bg-brand-orange/5" : "border-brand-line"}`} data-testid={`lb-row-${i}`}>
              <div className="font-mono-tabular text-2xl w-12 text-center">{trophy(i)}</div>
              <Medal className="w-5 h-5 text-brand-orange" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold truncate">{u.username || u.user_id}</div>
                <div className="text-xs text-zinc-500 font-mono-tabular">
                  {tab === "xp" ? `Level ${u.level || 0} · ${u.xp || 0} XP · ${u.messages || 0} msgs` : `${u.coins?.toLocaleString() || 0} coins`}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
